import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 37,
		height: 37,
		rx: 18.5,
		stroke: "#ffffff"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.7812 20.5C24.0938 20.5 26 22.4062 26 24.7188V25.5C26 26.3438 25.3125 27 24.5 27H13.5C12.6562 27 12 26.3438 12 25.5V24.7188C12 22.4062 13.875 20.5 16.1875 20.5C17.0938 20.5 17.5 21 19 21C20.4688 21 20.875 20.5 21.7812 20.5ZM24.5 25.5V24.7188C24.5 23.2188 23.2812 22 21.7812 22C21.3125 22 20.5938 22.5 19 22.5C17.375 22.5 16.6562 22 16.1875 22C14.6875 22 13.5 23.2188 13.5 24.7188V25.5H24.5ZM19 20C16.5 20 14.5 18 14.5 15.5C14.5 13.0312 16.5 11 19 11C21.4688 11 23.5 13.0312 23.5 15.5C23.5 18 21.4688 20 19 20ZM19 12.5C17.3438 12.5 16 13.875 16 15.5C16 17.1562 17.3438 18.5 19 18.5C20.625 18.5 22 17.1562 22 15.5C22 13.875 20.625 12.5 19 12.5Z",
		fill: "#ffffff"
	})]
});
export default SvgAccount;
